module.exports = __webpack_public_path__ + "static/media/house-1.b86d8aac.jpg";